export default __webpack_public_path__ + "static/media/Accessories.db68e804.webp";